import script from "./TableStylePanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./TableStylePanel.vue?vue&type=script&lang=ts&setup=true"

import "./TableStylePanel.vue?vue&type=style&index=0&id=79a422e5&lang=scss&scoped=true"

import exportComponent from "C:\\work\\to-create\\bailing\\yc-bailing-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-79a422e5"]])

export default __exports__